import { SET_FILTERS, CLEAR_FILTERS } from "./types";


export const setFilters = (payload: any) => (dispatch: any) => {  
  dispatch({ type: SET_FILTERS, payload: payload });
};

export const clearFilters = () => ({
  type: CLEAR_FILTERS,
});
